import axios from 'axios';
import { GoogleDriveError } from '../errors';

function errorHandler(error) {
  if (error.isAxiosError) {
    throw new GoogleDriveError(error.message, error.response.status);
  } else {
    throw new GoogleDriveError(error.message);
  }
}

export async function getGoogleDriveTokenInfo() {
  try {
    const tokenInfo = await axios({
      method: 'post',
      url: `/api/v1/auth/googleDrive/requestTokenInfo`
    });
    return tokenInfo.data;
  } catch (error) {
    errorHandler(error);
  }
}
export async function getDocumentFile(accessToken, fileid) {
  try {
    const binaryData = await axios({
      method: 'get',
      url: `https://www.googleapis.com/drive/v3/files/${fileid}?alt=media&supportsAllDrives=true`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      responseType: 'arraybuffer'
    });

    const fileInfo = await axios({
      method: 'get',
      url: `https://www.googleapis.com/drive/v3/files/${fileid}?supportsAllDrives=true`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json'
      }
    });

    const copyed = new File([binaryData.data], fileInfo.data.name, {
      type: fileInfo.data.mimeType
    });

    return copyed;
  } catch (error) {
    errorHandler(error);
  }
}
